  (function(){
    var drawer = document.querySelector('[data-wubs-cart-drawer]:not([data-wubs-cart-initialized])');
    if(!drawer) return;
    drawer.setAttribute('data-wubs-cart-initialized', 'true');
    var sid = drawer.getAttribute('data-wubs-cart-sid') || 'wubs';

    window.__wubsCartDrawerInit = window.__wubsCartDrawerInit || {};
    if(window.__wubsCartDrawerInit[sid]) return;
    window.__wubsCartDrawerInit[sid] = true;

    var header = document.getElementById('wubs-header-' + sid) || document;
    var cartLink = header.querySelector('.header__tools-icon--cart');
    var cartLinks = header.querySelectorAll('[data-wubs-cart-open]');
    var closeEls = drawer.querySelectorAll('[data-wubs-cd-close]');
    var itemsWrap = drawer.querySelector('[data-wubs-cd-items]');
    var countEl = drawer.querySelector('[data-wubs-cd-count]');
    var totalEl = drawer.querySelector('[data-wubs-cd-total]');
    var discountRow = drawer.querySelector('[data-wubs-cd-discount-row]');
    var discountEl = drawer.querySelector('[data-wubs-cd-discount]');
    var shippingEl = drawer.querySelector('[data-wubs-cd-shipping]');

    var FREE_THRESHOLD = Number(drawer.getAttribute('data-free-threshold')) || 0;
    var TXT_EMPTY = drawer.getAttribute('data-text-empty') || '';
    var TXT_QTY_MINUS = drawer.getAttribute('data-text-qty-minus') || '';
    var TXT_QTY_PLUS = drawer.getAttribute('data-text-qty-plus') || '';
    var TXT_REMOVE = drawer.getAttribute('data-text-remove') || '';
    var TXT_SHIPPING_FREE = drawer.getAttribute('data-text-shipping-free') || '';
    var TXT_SHIPPING_CALC = drawer.getAttribute('data-text-shipping-calc') || '';

    function stripMoneyZeros(formatted){
      return String(formatted || '').replace(/([,.])00\b/, '');
    }

    function money(cents){
      try{
        if(window.Shopify && typeof window.Shopify.formatMoney === 'function'){
          var fmt = (window.theme && (window.theme.moneyFormat || window.theme.money_format)) || window.Shopify.money_format || drawer.getAttribute('data-money-format') || '\u007b\u007bamount\u007d\u007d kr';
          return stripMoneyZeros(window.Shopify.formatMoney(cents, fmt));
        }
      }catch(e){}
      var val = (Number(cents) || 0) / 100;
      try{
        return new Intl.NumberFormat(drawer.getAttribute('data-locale') || document.documentElement.lang || undefined, {
          style: 'currency',
          currency: drawer.getAttribute('data-currency') || 'SEK',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(val);
      }catch(e){
        return stripMoneyZeros((Math.round(val * 100) / 100).toFixed(2));
      }
    }

    function escapeHtml(s){
      return String(s || '')
        .replace(/&/g,'&amp;')
        .replace(/</g,'&lt;')
        .replace(/>/g,'&gt;')
        .replace(/"/g,'&quot;')
        .replace(/'/g,'&#039;');
    }

    function setHeaderCount(cart){
      try{
        var n = Math.max(0, Number(cart && cart.item_count) || 0);
        document.dispatchEvent(new CustomEvent('wubs:cart-updated', { detail: { item_count: n } }));
      }catch(e){}
    }

    function setCartExpanded(expanded){
      for(var i=0;i<cartLinks.length;i++){
        cartLinks[i].setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    function open(){
      try{
        document.dispatchEvent(new CustomEvent('wubs:search-close', { detail: { sid: sid } }));
      }catch(e){}

      drawer.hidden = false;
      document.documentElement.classList.add('wubs-cart-open');
      setCartExpanded(true);
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          drawer.classList.add('is-open');
          refresh();
        });
      });
    }

    function close(immediate){
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('wubs-cart-open');
      setCartExpanded(false);
      if(immediate){
        drawer.hidden = true;
        return;
      }
      window.setTimeout(function(){
        if(!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 560);
    }

    function renderCart(cart){
      if(!cart) return;

      if(countEl) countEl.textContent = String(cart.item_count || 0);
      if(totalEl) totalEl.textContent = money(cart.total_price || 0);

      var disc = Number(cart.total_discount || 0);
      if(discountRow) discountRow.hidden = !(disc > 0);
      if(discountEl) discountEl.textContent = ' - ' + money(disc);

      if(shippingEl){
        if(FREE_THRESHOLD > 0 && (cart.total_price || 0) >= (FREE_THRESHOLD * 100)){
          shippingEl.textContent = TXT_SHIPPING_FREE;
        }else{
          shippingEl.textContent = TXT_SHIPPING_CALC;
        }
      }

      setHeaderCount(cart);

      if(!itemsWrap) return;

      if((cart.item_count || 0) === 0){
        itemsWrap.innerHTML = '<p style="margin:14px 0; opacity:.7;">' + escapeHtml(TXT_EMPTY) + '</p>';
        return;
      }

      var html = '';
      for(var i=0;i<(cart.items || []).length;i++){
        var it = cart.items[i];
        var line = i + 1;

        var vendor = (it.vendor || '').toString();
        var title = (it.product_title || it.title || '').toString();
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        var url = it.url || '#';

        var img = '';
        try{
          if(it.featured_image && it.featured_image.url) img = it.featured_image.url;
          else if(it.image) img = it.image;
        }catch(e){ img = ''; }

        var finalLine = Number(it.final_line_price || it.line_price || 0);
        var origLine = Number(it.original_line_price || finalLine);
        var hasDisc = origLine > finalLine;

        html += ''
          + '<div class="wubs-cd__item" data-wubs-cd-line data-line="' + line + '">'
          +   '<a class="wubs-cd__img" href="' + url + '">'
          +     (img ? '<img loading="lazy" src="' + img + '" alt="">' : '')
          +   '</a>'
          +   '<div>'
          +     '<p class="wubs-cd__vendor">' + escapeHtml(vendor) + '</p>'
          +     '<p class="wubs-cd__name">' + escapeHtml(title) + '</p>'
          +     (variant ? '<p class="wubs-cd__variant">' + escapeHtml(variant) + '</p>' : '')
          +     '<div class="wubs-cd__priceRow">'
          +       '<span class="wubs-cd__price">' + money(finalLine) + '</span>'
          +       (hasDisc ? '<span class="wubs-cd__compare">' + money(origLine) + '</span>' : '')
          +     '</div>'
          +     '<div class="wubs-cd__qtyRow">'
          +       '<div class="wubs-cd__qty">'
          +         '<button class="wubs-cd__qtyBtn" type="button" data-wubs-cd-qty="minus" aria-label="' + escapeHtml(TXT_QTY_MINUS) + '">-</button>'
          +         '<span class="wubs-cd__qtyNum" data-wubs-cd-qtynum>' + (it.quantity || 1) + '</span>'
          +         '<button class="wubs-cd__qtyBtn" type="button" data-wubs-cd-qty="plus" aria-label="' + escapeHtml(TXT_QTY_PLUS) + '">+</button>'
          +       '</div>'
          +     '</div>'
          +   '</div>'
          +   '<button class="wubs-cd__remove" type="button" data-wubs-cd-remove aria-label="' + escapeHtml(TXT_REMOVE) + '">'
          +     '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
          +   '</button>'
          + '</div>';
      }
      itemsWrap.innerHTML = html;
    }

    function refresh(){
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r){ return r.json(); })
        .then(function(cart){ renderCart(cart); return cart; })
        .catch(function(){});
    }

    function changeLine(line, qty){
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ line: line, quantity: qty })
      })
      .then(function(r){ return r.json(); })
      .then(function(cart){ renderCart(cart); return cart; });
    }

    function addVariant(variantId){
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
      .then(function(){ return fetch('/cart.js', { credentials:'same-origin' }); })
      .then(function(r){ return r.json(); })
      .then(function(cart){ renderCart(cart); return cart; });
    }

    if(cartLink){
      cartLink.addEventListener('click', function(e){
        e.preventDefault();
        open();
      });
    }

    document.addEventListener('wubs:cart-open', function(){
      open();
    });

    document.addEventListener('wubs:cart-close', function(e){
      var detail = e && e.detail ? e.detail : {};
      if(detail.sid && detail.sid !== sid) return;
      if(drawer.classList.contains('is-open') || !drawer.hidden) close(detail.immediate === true);
    });

    for(var i=0;i<closeEls.length;i++){
      closeEls[i].addEventListener('click', function(){ close(); });
    }

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    drawer.addEventListener('click', function(e){
      var t = e.target;
      if(!t) return;

      var addBtn = t.closest && t.closest('[data-wubs-cd-add]');
      if(addBtn){
        var vid = addBtn.getAttribute('data-variant-id');
        if(vid){
          addBtn.disabled = true;
          addVariant(vid).finally(function(){ addBtn.disabled = false; });
        }
        return;
      }

      var lineEl = t.closest && t.closest('[data-wubs-cd-line]');
      if(!lineEl) return;

      var line = Number(lineEl.getAttribute('data-line')) || 0;
      if(!line) return;

      if(t.closest && t.closest('[data-wubs-cd-remove]')){
        changeLine(line, 0);
        return;
      }

      var qtyBtn = t.closest && t.closest('[data-wubs-cd-qty]');
      if(qtyBtn){
        var type = qtyBtn.getAttribute('data-wubs-cd-qty');
        var numEl = lineEl.querySelector('[data-wubs-cd-qtynum]');
        var current = Number(numEl ? numEl.textContent : 1) || 1;
        var next = current;

        if(type === 'minus') next = Math.max(0, current - 1);
        if(type === 'plus') next = current + 1;

        changeLine(line, next);
      }
    });

    window.wubsCartDrawerOpen = window.wubsCartDrawerOpen || {};
    window.wubsCartDrawerOpen[sid] = open;

    refresh();
  })();
